export default __webpack_public_path__ + "static/media/Chat-Numbers-System-10.4c1d4962.svg";